<template>
  <div>
    <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item label="供应商">
            <a-select
              v-decorator="['profile_supplier_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingSupplierOptions"
            >
              <a-select-option
                v-for="opt in supplierOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="状态">
            <a-select
              v-decorator="['status']"
              allow-clear
              placeholder="请选择"
            >
              <a-select-option
                v-for="opt in statusOptions"
                :key="opt.value"
                :value="opt.value"
              >
                {{ opt.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="PRP规则">
            <a-select
              v-decorator="['prp_id']"
              allow-clear
              placeholder="请选择"
            >
              <a-select-option :value="1">1 - 全态开放（任意EID）</a-select-option>
              <a-select-option :value="2">2 - 删除/就绪态开放（任意EID）</a-select-option>
              <a-select-option :value="3">3 - 全态绑定（同一EID）</a-select-option>
              <a-select-option :value="4">4 - 删除/就绪态绑定（同一EID）</a-select-option>
              <a-select-option :value="5">5 - 错误敏感模式（同一EID）</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="SGP协议">
            <a-select
              v-decorator="['sgp_spec_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingSgpSpecOptions"
            >
              <a-select-option
                v-for="opt in sgpSpecOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="ICCID">
            <a-input
              v-decorator="['iccid', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="支持模糊搜索"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="MSISDN">
            <a-input
              v-decorator="['msisdn', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="支持模糊搜索"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">搜索</a-button>
              <a-button @click="handleReset">刷新</a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { findProfileSuppliers } from '@/api/profile_supplier'
import { findCommonTypeOptions } from '@/api/common_type'

export default {
  name: 'SearchProfileInventory',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'profile_inventory_search' }),
      supplierOptions: [],
      loadingSupplierOptions: false,
      sgpSpecOptions: [],
      loadingSgpSpecOptions: false,
      statusOptions: [
        { value: 'Available', label: '未被使用' },
        { value: 'Allocated', label: '已分配' },
        { value: 'Linked', label: '已关联 EID' },
        { value: 'Confirmed', label: '已订单确认' },
        { value: 'Released', label: '已发布（可下载）' },
        { value: 'Downloaded', label: '已下载' },
        { value: 'Installed', label: '已安装' },
        { value: 'Error', label: '发生错误' },
        { value: 'Unavailable', label: '不可用' },
        { value: 'Enable', label: '已启用' },
        { value: 'Disable', label: '已停用' },
        { value: 'Delete', label: '已删除' },
        { value: 'Preparing', label: '已准备' }
      ]
    }
  },
  created() {
    this.fetchSupplierOptions()
    this.fetchSgpSpecOptions()
  },
  methods: {
    fetchSupplierOptions() {
      this.loadingSupplierOptions = true
      findProfileSuppliers({ page: 1, per_page: 500 }).then((res) => {
        if (res.code === 0) {
          this.supplierOptions = res.data
        }
        this.loadingSupplierOptions = false
      })
    },

    fetchSgpSpecOptions() {
      this.loadingSgpSpecOptions = true
      findCommonTypeOptions('product_esim_sgp_spec').then((res) => {
        if (res.code === 0) this.sgpSpecOptions = res.data || []
        this.loadingSgpSpecOptions = false
      }).catch(() => { this.loadingSgpSpecOptions = false })
    },
    buildSearchParams(values) {
      const search = {}
      Object.keys(values || {}).forEach((key) => {
        const value = values[key]
        if (value === undefined || value === null || value === '') {
          return
        }
        if (Array.isArray(value) && value.length === 0) {
          return
        }
        search[key] = value
      })
      return search
    },

    handleSearch(e) {
      e.preventDefault()
      this.$emit('submit', this.buildSearchParams(this.form.getFieldsValue()))
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
